import * as TYPES from '../constants/errors/types';
import * as DETAILS from '../constants/errors/details';

/**
 * Engine error factory
 * @param {string} type
 * @param {string} initDetail
 * @param {boolean} initFatal
 * @param {boolean} initMonitored
 * @returns {function}
 * @param {Object} data
 * @param {string} data.context
 * @param {string} data.reason
 * @param {string} data.content
 * @param {boolean} data.fatal
 * @param {boolean} data.monitored
 * @param {string} data.detail
 */
const throwMediaEngineError =
  (type = TYPES.UNKNOWN_ERROR, initDetail = DETAILS.UNKNOWN, initFatal = true, initMonitored = true) =>
  ({ context, reason, content, fatal = initFatal, monitored = initMonitored, detail = initDetail }) => ({
    context,
    content,
    reason,
    type,
    fatal,
    monitored,
    detail,
  });

export const throwMethodOverloadError = throwMediaEngineError(
  TYPES.IMPLEMENTATION_ERROR,
  DETAILS.METHOD_MUST_BE_OVERLOADED,
);

export const throwNoPlayerError = throwMediaEngineError(TYPES.IMPLEMENTATION_ERROR, DETAILS.NO_PLAYER);

export const throwContainerErrorHelper = throwMediaEngineError(TYPES.BRIDGE_ERROR, DETAILS.NO_CONTAINER);

export const throwNoSourceErrorHelper = throwMediaEngineError(TYPES.BRIDGE_ERROR, DETAILS.NO_SOURCE);

export const throwEngineErrorHelper = throwMediaEngineError(TYPES.ENGINE_ERROR, undefined);

export const throwUnknownErrorHelper = throwMediaEngineError(TYPES.UNKNOWN_ERROR, DETAILS.UNKNOWN);

export const throwAutoplayErrorHelper = throwMediaEngineError(
  TYPES.IMPLEMENTATION_ERROR,
  DETAILS.AUTOPLAY_PREVENTED_ERROR,
);
